export default __webpack_public_path__ + "static/media/Unit_12_thumb.707e0c64.jpg";